import React, { useState, useEffect } from 'react';
import "../css/others/template.css";
import "../css/others/Table.css";
import { useNavigate } from 'react-router-dom';
import { apiCall } from '../main/ApiCall';
import Pagination from '../Reusablecomponents/Pagination';
import { EmailTemplate, createToastMessage, ToastMessage } from '../interFaces/interfaces';
import ToastPopup from '../popups/ToastPopup';
import EncryptionUtils from '../main/encryptionUtils';
const EmailTemplateUI: React.FC = () => {
  const [templates, setTemplates] = useState<EmailTemplate[]>([]);
  const [, setIsLoading] = useState(false);
  const [, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const clientId = localStorage.getItem("clientId");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [fields, setFields] = useState<any>({});
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions.tabs["emailTemplate"]) {
      setFields(permissions.tabs["emailTemplate"].fields);
    } else {
      console.log("No permissions found for 'emailTemplate' tab");
    }
  }, []);
  useEffect(() => {
    const fetchTemplates = async (clientId: string) => {
      setIsLoading(true);
      setError(null);
      try {
        const data = await apiCall('get', `/api/email-templates?clientId=${clientId}&page=${currentPage - 1}&size=${itemsPerPage}`);
        setTemplates(data.content);
        setTotalPages(data.totalPages);
        setTotalElements(data.totalElements);
      } catch (err: any) {
        if (err.response?.status === 404) {
          setTemplates([]);
        } else {
          console.error('Error fetching templates:', err);
        }
      }
    };
    if (clientId) {
      fetchTemplates(clientId);
    }
  }, [clientId, currentPage, itemsPerPage]);
  const handleSync = async () => {
    if (!clientId) return;
    setIsLoading(true);
    try {
      await apiCall("post", `/api/email-templates/sync?clientId=${clientId}`);
      const data = await apiCall('get', `/api/email-templates?clientId=${clientId}&page=${currentPage - 1}&size=${itemsPerPage}`);
      setTemplates(data.content);
      setTotalPages(data.totalPages);
      setTotalElements(data.totalElements);
      setMessage(createToastMessage('Sync completed successfully!', "success", 3000));
    } catch (err: any) {
      setMessage(createToastMessage('Sync failed. Please try again!', "error", 3000));
    } finally {
      setIsLoading(false);
    }
  };
  const handleCreateNew = () => { if (clientId) { navigate(`/createtemplate/${clientId}`); } };
  const handleEdit = (template: EmailTemplate) => { if (clientId && template.templateId) { navigate(`/emailtemplatedetail/${clientId}/${template.templateId}`); } };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Email Templates</h2>
        <div className="table-title-actions">
          {fields.create && (
            <>
              <button className="createnewtemplate" onClick={handleCreateNew}>Create New Template</button>
              <button className="sync" onClick={handleSync}>Sync</button>
            </>
          )}
        </div>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr><th>Template Name</th><th>Template Type</th></tr>
            </thead>
            <tbody>
              {templates.length === 0 ? (
                <tr><td colSpan={2} className="no-data">No templates for this client ID.</td></tr>
              ) : (
                templates.map((template) => (
                  <tr key={template.templateId}>
                    <td>{fields.view && (
                      <span className="clickable" onClick={() => handleEdit(template)} title="Click to edit">{template.name}</span>
                    )}</td>
                    <td>{template.type}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default EmailTemplateUI;